import {AbstractService} from 'services/AbstractService';

const SEARCH_URL = '/api/search';

export class SearchService extends AbstractService {

  find (query, entityType, summarySearch = false, accountId = null) {
    return this.client.get(
      SEARCH_URL,
      {
        query,
        type: entityType,
        summary_search: summarySearch
      },
      {
        accountId,
        forceNullAccount: !accountId
      }
    );
  }

}
